import {faSpinner} from '@fortawesome/free-solid-svg-icons';

export default{
    loadingIcon:faSpinner,
    emptySpace:' '
};